import useStyles from '../Header.styles';

function HeaderBgr({ isQuickPicks }: { isQuickPicks?: boolean }) {
  const { classes } = useStyles();
  const stopColor = isQuickPicks ? '#34213C' : '#4BEBE2';

  return (
    <svg
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes.svgBgr}
    >
      <rect width="100%" height="100%" fill="#101113" />
      {isQuickPicks ? (
        <rect width="100%" height="100%" fill="url(#header_violet_gradient)" fillOpacity="1" />
      ) : (
        <rect width="100%" height="100%" fill="url(#header_green_gradient)" fillOpacity="0.3" />
      )}
      <defs>
        <linearGradient
          id="header_green_gradient"
          x1="-2"
          y1="-35"
          x2="9.66961e-06"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={stopColor} />
          <stop offset="1" stopColor={stopColor} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="header_violet_gradient"
          x1="147"
          y1="58.5"
          x2="143.5"
          y2="-28.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#34213C" stopOpacity="0" />
          <stop offset="1" stopColor="#34213C" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default HeaderBgr;
